export const SUPPLY_CHAIN_JOIN_SIMULATION_START = "SUPPLY_CHAIN_JOIN_SIMULATION/SUPPLY_CHAIN_JOIN_SIMULATION_START";
export const SUPPLY_CHAIN_JOIN_SIMULATION_FAIL = "SUPPLY_CHAIN_JOIN_SIMULATION/SUPPLY_CHAIN_JOIN_SIMULATION_FAILED";
export const SUPPLY_CHAIN_JOIN_SIMULATION_SUCCESS = "SUPPLY_CHAIN_JOIN_SIMULATION/SUPPLY_CHAIN_JOIN_SIMULATION_SUCCESS";
